import { NodeSpec } from 'prosemirror-model';
import { Command } from 'prosemirror-state';

import { BaseExtension } from '@lyearn/lygo-core';

import { handleBackspaceInHeading, handleEnterInHeading } from './commands';
import { NODE_NAME } from './consts';
import plugins from './plugins';

export default class ToggleHeading extends BaseExtension {
  get schema(): NodeSpec {
    return {
      content: 'paragraph',
      toDOM: () => ['div', { class: '-mt-16' }, 0],
    };
  }

  get name(): string {
    return NODE_NAME;
  }

  get keys(): { [key: string]: Command } | null {
    return {
      Backspace: handleBackspaceInHeading,
      Enter: handleEnterInHeading,
    };
  }

  plugins = plugins;
}
